/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FacilityServiceArea } from './FacilityServiceArea';
import {
    FacilityServiceAreaFromJSON,
    FacilityServiceAreaFromJSONTyped,
    FacilityServiceAreaToJSON,
    FacilityServiceAreaToJSONTyped,
} from './FacilityServiceArea';

/**
 * 
 * @export
 * @interface CreateFacilityServiceArea201Response
 */
export interface CreateFacilityServiceArea201Response {
    /**
     * 
     */
    data?: FacilityServiceArea;
}

/**
 * Check if a given object implements the CreateFacilityServiceArea201Response interface.
 */
export function instanceOfCreateFacilityServiceArea201Response(value: object): value is CreateFacilityServiceArea201Response {
    return true;
}

export function CreateFacilityServiceArea201ResponseFromJSON(json: any): CreateFacilityServiceArea201Response {
    return CreateFacilityServiceArea201ResponseFromJSONTyped(json, false);
}

export function CreateFacilityServiceArea201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFacilityServiceArea201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : FacilityServiceAreaFromJSON(json['data']),
    };
}

export function CreateFacilityServiceArea201ResponseToJSON(json: any): CreateFacilityServiceArea201Response {
    return CreateFacilityServiceArea201ResponseToJSONTyped(json, false);
}

export function CreateFacilityServiceArea201ResponseToJSONTyped(value?: CreateFacilityServiceArea201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': FacilityServiceAreaToJSON(value['data']),
    };
}

